var _rect, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBankSlipIcon = function SvgBankSlipIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.0801,
    y: 20.6309,
    width: 36.4933,
    height: 17.4533,
    transform: "rotate(-180 38.0801 20.6309)",
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4933 0.793333H3.17333C1.8589 0.793333 0.793333 1.8589 0.793333 3.17333V20.6267C0.793333 21.9411 1.8589 23.0067 3.17333 23.0067H36.4933C37.8078 23.0067 38.8733 21.9411 38.8733 20.6267V3.17333C38.8733 1.8589 37.8078 0.793333 36.4933 0.793333ZM3.17333 0C1.42075 0 0 1.42075 0 3.17333V20.6267C0 22.3792 1.42075 23.8 3.17333 23.8H36.4933C38.2459 23.8 39.6667 22.3792 39.6667 20.6267V3.17333C39.6667 1.42075 38.2459 0 36.4933 0H3.17333Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1622_2557",
    transform: "translate(0 -0.19) scale(0.02 0.0418182)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1622_2557",
    width: 50,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAYAAACbffiEAAABmklEQVRYCe2ZMW6EQAxFzSHgHLkAEkfZg3AlUHqQsjVdoKPJllBlUyIlInqED7NSlBoiI1m2scfzvawZxmO2X5mZvZjZu5nNBycwghXMD9clSZKuKIpuGIb7NE3zkQmMYAWzmV2USRbHcXtk4H9hA7uZPZHMtSzLDudxHOe6rhdCli7e9/3ypJqmmZHh+Gsi7qFrLLpIY0JfZPyxiTQXemhHlo2YigN2M3smkbdhGD4wVFU1R1G0ELJ08TzPlwBpms7IcPwVlHvoGosu0pjQFxl/bCLNhR7akWUjpuKAnRxIhJtfoWMIRjJcAQQKzn0FxS5/JlUScI0JfZHxxyYSWPTQjiybcKyxPtcXkyey/Ir+RNb/uf+19rXOa2R7A/Fm8RrxGtnXM19HtKJSG1qtvUa8RrxGfj7LqQWvEf+M3/crvh9hN6YdmbjXiNeI18j52kHTNG07xNs/6GvdHjqN6/f91qc6gx52GrMkSV7PAPo3jGBX75enQje+LcuyPUs3HqxgDrvxJMLFWcPVzO4HPxvh7AaMYN3OR74BV1ejVpRlWyoAAAAASUVORK5CYII="
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankSlipIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank_slip_icon.b800dbe4.svg";
export { ForwardRef as ReactComponent };